export const RFID_FILE_UPLOAD_REQUEST = 'RFID_FILE_UPLOAD_REQUEST';
export const RFID_FILE_UPLOAD_SUCCESS = 'RFID_FILE_UPLOAD_SUCCESS';
export const RFID_FILE_UPLOAD_FAILURE = 'RFID_FILE_UPLOAD_FAILURE';

export const RFID_FILE_UPLOAD_SET_SUBMITTED = 'RFID_FILE_UPLOAD_SET_SUBMITTED';
